export default {
  lang: 'English',
  langList:[
    {
      label:'Chinese',
      value:'cn',
    },
    {
      label:'English',
      value:'en',
    },
  ],
  message: {
    hello: 'Welcome',
    copiedToTheClipboard: 'Copied to Clipboard',
    fileGenerating: 'File Generating...',
    asterisk: {
      title: 'Notes',
      message: 'Content you are unauthorized to view will be replaced with ****'
    },
    info: {
      articleTranslateHint: 'Note: The content is machine translation, for reference only. Please refer to the original text for details.'
    },
    success: {
      favorite: 'Collected',
      unfavored: 'Collection Canceled',
      up: 'Top Succeeded',
      unUp: 'Top Canceled',
      delete: 'Deletion Succeeded'
    },
    error: {
      server: 'Server Error',
      favorite: 'Collection Failed!',
      unfavored: 'Collection Cancellation Failed!',
      up: 'Top Failed',
      selectCountry: 'Select A Country',
      noData: 'No Data Fetched',
      searchKeyMaxLength: '',
      maximum100: 'No More Than 100 Characters'
    },
    warning: {
      selectOne: 'Select At Least One Item to Export',
      noFavorite: 'No Items to Collect',
      noId: 'No ID',
      information: {
        noData: 'No Access to Data Return List Page'
      },
      prompt: {
        title: 'Tips',
        export: 'Do you want to export all list data under this column?',
        exportFailure: 'Export Failed'
      },
      exhibition: {
        historyClearUnsupported: 'Clearing all search history is not supported for exhibitions',
        historyTopUnsupported: 'Pinning search history is not supported for exhibitions',
        historyDeleteUnsupported: 'Deleting a single search history item is not supported for exhibitions'
      }
    }
  },
  rootTitle: 'Belt and Road Project Opportunities and Risk Analysis',
  fullScreen: 'Full Screen',
  exitTheFullScreen: 'Exit Full Screen',
  exit: 'Exit',
  loading: 'Loading...',
  noMoreData: 'No More Data',
  noData: 'No Data',
  header: {
    home: 'Home',
    bidding: 'Overseas Bidding',
    exhibition: 'International Exhibitions',
    project: 'Project',
    information: 'Information',
    analysis: 'Analysis',
    special: 'Special'
  },
  theme: {
    white: 'Light',
    dark: 'Dark'
  },
  tabs: {
    home: {
      latestProject: 'Latest Projects',
      keyProject: 'Key Projects',
      myProject: 'My Project',
      releaseProject:'Release Project',
      projectOpportunity: 'Business Opportunities',
      projectRisk: 'Project Risks',
      projectInformation: 'Project Information',
      projectConcerns: 'Project Concerns',
      addConcerns: 'Add Follow',
      myCollections: 'My Collection',
      relevantRecommendations: 'Relevant Recommendations',
      project: 'Projects',
      opportunity: 'Business Opportunities',
      risk: 'Risks',
      enterprise: 'Enterprises',
      information: 'Information'
    },
    information: {
      projectInformation: 'Project Information',
      opportunityInformation: 'Opportunity Information',
      riskInformation: 'Risk Information',
      riskEvent: 'Risk Events',
      multilateralDynamics: 'Multilateral Dynamics'
    },
    analysis: {
      countryComparison: 'Country Comparison',
      industryComparison: 'Industry Comparison',
      opportunityAnalysis: 'Business Analysis',
      riskAnalysis: 'Risk Analysis',
      networkVolume: 'Network Volume',
      positiveAndNegativeSidesOfInformation: 'Positive And Negative Sides Of Information',
      exportReport: 'Export A Report',
      projectList:'Project List'
    },
    special: {
      regionalDistribution: 'Regional Distribution',
      industryDistribution: 'Industry Distribution',
      informationAtlas: 'Information Atlas',
      hotWordAnalysis: 'Hot Word Analysis',
      more:{
        projectTitle:'More Projects',
        infoTitle:'More Information',
      }
    }
  },
  charts: {
    home: {
      project: {
        industryDistribution: 'Industry Distribution',
        countries: 'Country and Region',
        number: 'Number of Projects'
      },
      opportunity: {
        countriesDistribution: 'Country and Region',
        distribution: 'Business Distribution',
        trend: 'Business Trend',
        number: 'Number of Categories',
        percentage: 'Percentage'
      },
      risk: {
        countriesDistribution: 'Country and Region',
        distribution: 'Risk Distribution',
        trend: 'Risk Trend',
        date: 'Risk Date',
        number: 'Number of Categories',
        percentage: 'Percentage'
      }
    },
    analysis: {
      unit: 'Unit',
      yuan: 'Yuan',
      ge: 'Number',
      tiao: 'Piece',
      exportSelected: 'Please select at least one content to export',
      exporting: 'Analysis Report Is Being Prepared',
      countryComparison: {
        countryComparisonOfProjectQuantity: 'Project Quantity by Country',
        nationalTrendChartOfProjectQuantity: 'Project Quantity Trend by Country',
        countryComparisonChartOfProjectAmount: 'Project Amount by Country',
        nationalTrendChartOfProjectAmount: 'Project Amount Trend by Country'
      },
      industryComparison: {
        projectQuantityIndustryComparisonChart: 'Project Quantity by Industry',
        projectQuantityIndustryTrendChart: 'Project Quantity Trend by Industry',
        industryComparisonChartOfProjectAmount: 'Project Amount by Industry',
        industryTrendChartOfProjectAmount: 'Project Amount Trend by Industry'
      },
      opportunityAnalysis: {
        businessOpportunityCountryTrendChart: 'Business Opportunity Trend by Country',
        businessOpportunityTypeTrendChart: 'Business Opportunity Trend by Type',
        businessOpportunityCountryDistributionMap: 'Business Opportunity Distribution by Country',
        businessOpportunityTypeDistributionMap: 'Business Opportunity Distribution by Type'
      },
      riskAnalysis: {
        riskEventCategoryTrendChart: 'Risk Event Trend by Type',
        nationalTrendChartOfRiskEvents: 'Risk Event Trend by Country',
        riskEventCategoryDistributionMap: 'Risk Event Distribution by Type',
        countryDistributionMapOfRiskEvents: 'Risk Event Distribution by Country'
      },
      networkVolume: {
        volumeInformationTrendChart: 'Project Volume Trend Chart',
        informationSourceTrendChart: 'Project Volume  Trend Chart by Country',
        distributionMapOfInformationSources: 'Project Volume  Distribution Chart by Country',
        comparisonOfInformationSources: 'Project Volume  Source Distribution Chart '
      },
      positiveAndNegativeSidesOfInformation: {
        positive: 'Positive',
        negative: 'Negative',
        informationPositiveAndNegativeComparisonDiagram: 'Positive and Negative Information  Comparison Diagram',
        proportionOfSensitiveInformation: 'Positive and Negative Information  Comparison Diagram by Country',
        positiveInformationTrendChart: 'Positive Information Trend Chart',
        distributionOfPositiveInformationSources: 'Distribution of Positive Information Sources',
        sensitiveInformationTrendChart: 'Negative Information Trend Chart',
        distributionOfSensitiveInformationSources: 'Distribution of Negative Information Sources'
      }
    },
    special: {
      industryDistribution: {
        name: 'Industry Distribution'
      },
      regionalDistribution: {
        name: 'Regional Distribution'
      }
    }
  },
  buttons: {
    okButton: 'Ok',
    ok: 'Ok',
    cancelButton: 'Cancel',
    cancel: 'Cancel',
    search: 'Search',
    reset: 'Reset',
    edit: 'Edit',
    close: 'Close',
    more: 'More',
    submit: 'Submit',
    searchHistory: 'Previous<br/>Search',
    delAll: 'Delete All',
    advanceRetrieval: 'Advance<br/>Search<i class=\'el-icon-arrow-{type} el-icon--right\'></i>',
    export: 'Export',
    back: 'Back',
    switch: {
      fuzzy: 'Ambiguity',
      accurate: 'Precision'
    },
    home: {
      advanceOkButton: 'Ok',
      advanceCancelButton: 'Cancel',
      mapDetailButton: 'Detail >>'
    },
    project: {
      publishProject: 'Release A Project',
      projectAnalysis: 'Project Analysis'
    },
    information: {
      time: 'Time',
      correlationDegree: 'Relevancy'
    },
    analysis: {},
    special: {},
    personal: {
      focus: 'Follow'
    }
  },
  label: {
    continent: 'Continent',
    country: 'Country',
    enterprise: 'Enterprise',
    industry: 'Industry',
    category: 'Category',
    stage: 'Stage',
    amount: 'Amount',
    signDate: 'Contract Date',
    keyProject: 'Key Project',
    theDateRange: 'Date Range',
    date: 'Date',
    source: 'Source',
    implement: 'Implementation',
    signAContract: 'Contract Signing',
    trade: 'Trade',
    capitalConstruction: 'Infrastructure',
    investmentAndFinancing: 'Investment And Financing',
    home: {
      keywordInputPlaceholder: 'Enter A Keyword',
      filterTableColumnName: 'Name',
      filterTableColumnLogo: 'National Flag',
      date: 'Date',
      amount: 'Amount',
      country: 'Country',
      type: 'Type',
      enterprise: 'Enterprise',
      loadDataError: 'Data Loading Failed',
      retry: 'Retry',
      map: {
        download: 'Download',
        country: 'Country',
        number: 'Number of Projects',
        printing: 'Start printing a map within the current visual range...',
        project: 'Projects',
        opportunity: 'Business',
        risk: 'Risks',
        tooltip:{
          xm:'Project List',
          sj:'Business List',
          fx:'Risk List'
        }
      }
    },
    project: {
      country: 'Country: ',
      enterprise: 'Enterprise: ',
      industry: 'Industry: ',
      category: 'Category: ',
      stage: 'Phase: ',
      amount: 'Amount: ',
      signDate: ' Contract Date: ',
      keyProject: 'Key Project: ',
      date: 'Date: ',
      searchCondition: 'My Search Criteria: ',
      projectData: 'Project Data',
      projectHotWords: 'Project Hot Words',
      total: 'Total',
      projectNumber: 'Number of \nProjects',
      countriesInvolved: 'Countries\nInvolved',
      projectAmount: 'Project\nAmount',
      industriesInvolved: 'Industries\nInvolved',
      individual: '',
      HM: '',
      million: 'million Yuan',
      publish: {
        title: 'Release A Project',
        myPublish: 'My Release',
        submitSuccess: 'Submit Successfully',
        submitFailure: 'Submit Failure',
        base: {
          title: 'Basic Information',
          projectName: 'Project Name',
          investmentAmount: 'Investment Amount',
          projectCountry: 'Country Involved',
          detailedAddress: 'Detailed Address',
          projectIndustry: 'Industry Involved',
          projectType: 'Project Type',
          participationMode: 'Participation Mode',
          projectStatus: 'Project Status',
          unitName: 'Unit Name',
          financingSituation: 'Financing Situation',
          overview: 'Project Overview',
          signDate: 'Contract Date',
          signAmount: 'Contract Amount',
          planStartDate: 'Planned Start Date',
          planEndDate: 'Planned Completion Date',
          realityStartDate: 'Actual Start Date',
          realityEndDate: 'Actual Completion Date',
          planBuildCycle: 'Planned Construction Period',
          realityBuildCycle: 'Actual Construction Period',
          lang:'language'
        },
        contact: {
          title: 'Contact Information',
          contact1: 'Contact 1',
          mobile1: 'Mobile Number 1',
          email1: 'Email 1',
          telephone1: 'Telephone 1',
          contact2: 'Contact 2',
          mobile2: 'Mobile Number 2',
          email2: 'Email 2',
          telephone2: 'Telephone 2'
        }
      },
      detail: {
        title: 'Project Details',
        basicInformation: 'Basic Information',
        projectName: 'Project Name',
        projectBrief: 'Project Overview',
        countryOrRegion: 'Country/Region',
        signDate: 'Contract Date',
        updateDate: 'Update Date',
        projectIndustry: 'Industry Involved',
        projectStage: 'Project Phase',
        constructionCycle: 'Construction Period',
        projectType: 'Project Type',
        projectAmount: 'Project Amount',
        projectContact: 'Project Contact',
        subsidiaryOrgan: 'Contact Organization',
        position: 'Contact Position',
        projectBidPublishDate: 'Bidding Release Date',
        projectEndDate: 'Bidding Deadline',
        contact: 'Contact Information',
        enterpriseName: 'Builders',
        constructionName: 'Construction Unit',
        owner:'Project Owner',
        otherInformation: 'Other Information',
        constructionInformation: 'Construction Information',
        investmentInformation: 'Investment Information',
        tradeInformation: 'Trade Information',
        planStartDate: 'Planned Start Date',
        planEndDate: 'Planned Completion Date',
        excutedMode: 'Execution mode',
        realityStartDate: 'Actual Start Date',
        realityEndDate: 'Actual Completion Date',
        projectConstructionCycle: 'Project Construction Period',
        technicalStandard:'Technical Standard',
        financingSubject:'Finance Company',
        financingPurpose:'Financing Purposes',
        investor:'Investment Company',
        finRevenueProfit:'Revenue Last Year',
        finCurrentAssets:'The Current Assets',
        finFinanceMoney:'Financing Amount',
        finFinanceStage:'Financing Phase',
        finFinanceWay:'Financial Mode',

        importExportType:'Import and Export Type',
        startEndTime:'Beginning and Ending Time',
        currencySystem:'Currency',
        tradingPartners:'Trade Partner',
        tradeMode:'Mode of Trade',
        placeRegistrationReceive:'Registration Place',
        customsCategory:'Customs Category',
        shippingType:'Mode of Transport',

        historyInformation: 'Real-time Updates',
        no: 'No.',
        updateContent: 'Updates',
        relatedInformation: 'Related Information',
        update: 'Change the Date',
        mileStone: 'Milestone',
        demandBudget: 'Demand Budget',
        bidType: 'Bidding Type',
        projectDomain: 'Project Domain',
        projectWinning: 'Winning the Bid', /* ProjectWinning */
        projectSigning: 'Contract Signing', /* ContractSigning */
        projectStarted: 'Start of Project', /* ProjectStarts */
        stageAcceptance: 'Stage Acceptance', /* StageAcceptance */
        projectCompletion: 'Project Completion', /* ProjectCompletion */
        projectAtlas: 'Project Atlas',
        relatedEnterprises: 'Related Enterprises',
        relatedIndustries: 'Related Industries',
        relatedProjects: 'Related Projects',
        externalPoliticalRisk: 'Overseas Political Risks',
        sovereignPoliticalRisk: 'Sovereignty Risks',
        riskOfSocialUnrest: 'Risk of social unrest',
        riskOfRelationsWithChina: 'Risk in relations with China',
        capitalRisk: 'Capital Risks',
        financialRisk: 'Financial Risks',
        inflationRisk: 'Inflation Risks',
        exchangeRateRisks: 'Exchange Rate Risks',
        environmentalRisk: 'Environmental Risks',
        legalRisk: 'Legal Risks',
        emergencyRisk: 'Emergency Risks',
        projectImplementationRisk: 'Implementation Risks',
        enterpriseRisk: 'Enterprise Risks',
        otherRisks: 'Other Risks',
        relevantRiskEvents: 'Relevant Risk Events',
        relevantNationalLaws: 'Business Guide',
        policiesAndRegulations:'Policies And Regulations',
        commonWebsiteLinks:'Common WebsiteLinks',
        projectAttachments:'Project Attachments',
        fileName:'File Name',
        previewLink:'Preview',
        countryRelatedInformation: 'Country-related Information',
        relevantInformation: 'Relevant Information',
        relatedBusinessOpportunities: 'Related Business Opportunities',
        disclaimer: 'Disclaimer',
        disclaimerContent: 'All project information in this section is sourced from traceable public channels such as overseas governments and international organizations (hereinafter referred to as "Information Sources"). The platform has exercised due diligence in assessing the credibility of information sources, but cannot guarantee or warrant the accuracy, completeness, or timeliness of content published by information sources. The platform shall not be liable for errors, omissions, or delays in updates published by information sources, or for circumstances arising from force majeure, technical obstacles, or other causes not due to the platform\'s intentional misconduct or gross negligence. Where project details presented electronically on this platform are inconsistent with those officially released by the project owner, the owner\'s published content shall prevail. Overseas projects are subject to significant influence from various complex factors in the host country or region, including politics, economics, law, culture, exchange rate fluctuations, and policy changes, resulting in high uncertainty and inherent risks; the platform does not evaluate the compliance, feasibility, or potential risks of projects, and users should consult professional institutions on their own.',
        contactHint: 'For more project details, please contact: 010-88057118 or 4006123115'
      },
      status:{
        1:'Valid',
        2:'Invalid',
        0:'Unknown'
      }
    },
    exhibition: {
      exhibitionNumber: 'Exhibitions',
      onGoingExhibition: 'Ongoing Exhibitions',
      upcomingExhibition: 'Upcoming Exhibitions',
      internationalExhibition: 'International Exhibitions',
      globalProject: 'Global Projects',
      overseasTendering: 'Overseas Tending',
      exhibitionData: 'Exhibition Data',
      exhibitionHotWords: 'Exhibition Hot Words',
      holdStatus: 'Exhibition Status',
      holdStatusPlaceholder: 'Select exhibition status',
      holdStartDate: 'Start Date',
      holdEndDate: 'End Date',
      nextStartDate: 'Next Start Date',
      nextEndDate: 'Next End Date',
      holdDate: 'Hold Date',
      nextDate: 'Next Session Date',
      holdCycle: 'Hold Cycle',
      cycleTimes: ' times',
      detail: {
        title: 'Exhibition Details',
        basicInformation: 'Basic Information',
        exhibitionName: 'Exhibition Name',
        city: 'City',
        industry: 'Industry',
        relatedField: 'Related Field',
        audience: 'Audience',
        holdDate: 'Hold Date',
        nextHoldDate: 'Next Hold Date',
        venueInfo: 'Venue Information',
        venueName: 'Venue Name',
        venueAddress: 'Venue Address',
        venueContact: 'Venue Contact',
        organizerInfo: 'Organizer Information',
        organizerName: 'Organizer Name',
        organizerAddress: 'Organizer Address',
        organizerContact: 'Organizer Contact',
        description: 'Description'
      }
    },
    enterprisePage: {
      detail: {
        basicInformation: 'Basic Information',
        title: 'Enterprise Details',
        projectList: 'Project List',
        enterpriseAtlas: 'Enterprise Atlas',
        relevantInformation: 'Relevant Information',
        unifiedCreditCode: 'Unified Credit Code',
        legalRepresentative: 'Legal Representative',
        operatingStatus: 'Operating Status',
        dateOfEstablishing: ' Date Of Establishing',
        companyType: 'Company Type',
        province: 'Province',
        usedName: 'Used Name',
        registrationAuthority: 'Registration Authority',
        chineseName: 'Chinese Name',
        englishName: 'English Name',
        contactNumber: 'Contact Number',
        natureOfBusiness: 'Business Scope',
        noCompanyInfo: 'No Record of Basic Information of the Enterprise'
      }
    },
    information: {
      category: 'Category',
      informationHotWords: 'Information Hot Words',
      informationHotspot: 'Information Hotspot',
      informationRiskHotWords: 'Risk Hot Words',
      informationRiskHotspot: 'Risk Hotspot',
      multilateral: {
        org: 'Multilateral Organization',
        region: 'Region',
        infoType: 'Information Type',
        infoCategory: 'Information Category',
        regionOverview: 'Regional Overview',
        dynamicsUnit: 'dynamics',
        detailTitle: 'Multilateral Dynamics Details',
        publishTime: 'Publish Time: ',
        andMore: ' etc.',
        disclaimer: '[Statement: This content is a factual excerpt and objective restatement of publicly available reports from home and abroad, and is for reference only. Accuracy is sought but not guaranteed. In case of any factual discrepancy, the original report shall prevail.]'
      },
      detail: {
        title: 'Information Details',
        projectTitle: 'Project Information Details',
        riskTitle: 'Risk Information Details',
        businessTitle: 'Business Information Details',
        source: 'Source: ',
        author: 'Author: ',
        originalLink: 'Copy Original Link',
        originalDetails: 'Original Details',
        translateDetails: 'Translated Details',
        informationAtlas: 'Information Atlas',
        relevantInformation: 'Relevant Information',
        summary: 'Abstract: ',
        time: 'Original Release Date: ',
        publishDate: 'Database Release Date: '
      },
      business: {
        title: 'Business Details',
        relatedItems: 'Related Projects'
      },
      risk: {
        title: 'Risk Details',
        relatedEnterprises: 'Related Enterprises',
        updatedTime: 'Updated Time'
      }
    },
    analysis: {
      atlasAnalysis: 'Atlas Analysis',
      hotWordAnalysis: 'Hot Word Analysis',
      country: 'Country: ',
      enterprise: 'Enterprise: ',
      signDate: 'Contract Date: ',
      industry: 'Industry: ',
      phase: 'Phase: ',
      category: 'Category: ',
      amount: 'Amount: ',
      exportReport: {
        title: 'Report Content Selection',
        summary: 'Overview',
        projectInformation: 'Project information(Less Than Fifty)',
        watermark: 'With Watermark',
        watermarkNo: 'Without Watermark',
        cancel: 'Cancel',
        confirm: 'Confirm'
      }
    },
    special: {
      key: '“Test system” special',
      title: 'Bank of China successfully co organized the "entrepreneur conference docking and negotiation activity"',
      summary: 'On the afternoon of April 25, the second "test system" International Cooperation Summit Forum entrepreneur conference was successfully held in the National Convention Center (Beijing). This docking negotiation was hosted by the China Council for the',
      distributionOfRelatedProjects: 'Distribution Of Related Projects',
      projectRelatedInformation: 'Project-Related Information',
      relatedItems: 'Related Projects',
      relevantInformation: 'Relevant Information',
      regionalDistributionDesc: 'From 2005 to 2016, the total investment supported by the Bank of China in test system countries was US $204.7 billion, showing an overall upward trend. Among the four regions of test system, East Asia and West Asia accounted for most of the investment, and the upward trend is relatively more significant.',
      industryDistributionDesc: 'The Bank of China has successively signed memorandums of cooperation on the test system with the Philippines, the Czech Republic, Cambodia and other countries, and strongly',
      informationAtlasDesc: 'The Bank of China has successively signed memorandums of cooperation on the test system with the Philippines, the Czech Republic, Cambodia and other countries, and strongly supported the development and investment of projects in countries along the test system.',
      hotWordAnalysisDesc: 'From 2005 to 2016, the total investment supported by the Bank of China in test system countries was US $204.7 billion, showing an overall upward trend. Among the four regions of test system, East Asia and West Asia accounted for most of the investment, and the upward trend is',
      more: {
        projectTitle: 'More Projects',
        infoTitle: 'More Information'
      }
    },
    personal: {
      setMyAttention: 'Set My Follow',
      moreCountry: 'More Countries',
      focused: 'Followed',
      myFocused: 'My Follow'
    },
    export: {
      projectList: 'Project List',
      biddingList: 'Overseas Bidding Project List',
      exhibitionList: 'Exhibition List',
      project: 'Project Details - ',
      infoList: 'Information List',
      info: 'Information Details - ',
      riskList: 'Risk List',
      risk: 'Risk Details - ',
      multilateralList: 'Multilateral Dynamics List',
      multilateral: 'Multilateral Dynamics Details - '
    }
  },
  placeholders: {
    pleaseSelect: 'Please Select',
    project: {
      search: 'Enter Project Name, Industry, Category and Other Keywords',
      searchByName: 'Enter Project Name',
      publish: {
        base: {
          title: 'Basic Information',
          projectName: 'Enter Project Name',
          investmentAmount: 'Enter Investment Amount',
          projectCountry: 'Select A Country',
          detailedAddress: 'Enter Full Address',
          projectIndustry: 'Select An Industry',
          projectType: 'Select Project Type',
          participationMode: 'Select Participation Mode',
          projectStatus: 'Select Project Status',
          unitName: 'Enter Unit Name',
          financingSituation: 'Enter Investment and Financing Information',
          overview: 'Enter Project Overview',
          signDate: 'Select Contract Date',
          signAmount: 'Enter Contract Amount',
          planStartDate: 'Select Planned Start Date',
          planEndDate: 'Select Planned Completion Date',
          realityStartDate: 'Select Actual Start Date',
          realityEndDate: 'Select Actual Completion Date',
          planBuildCycle: 'Enter Planned Construction Period',
          realityBuildCycle: 'Enter Actual Construction Period',
          lang:'Select Language'
        },
        contact: {
          title: 'Contact Information',
          contact1: 'Enter Contact 1',
          mobile1: 'Enter Mobile Number 1',
          email1: 'Enter Email 1',
          telephone1: 'Enter Tel Number 1',
          contact2: 'Enter Contact 2',
          mobile2: 'Enter Mobile Number 2',
          email2: 'Enter Email 2',
          telephone2: 'Enter Tel Number 2'
        }
      }
    },
    information: {
      theDateRange: 'Date Range',
      keywords: 'Enter Keywords',
      selectOrSearch: 'Please select or search',
      source: 'Enter source'
    },
    exhibition: {
      search: 'Enter exhibition name, country, industry and other keywords'
    }
  },
  table: {
    exhibition: {
      main: {
        name: 'Exhibition Name',
        city: 'City',
        holdDate: 'Hold Date',
        holdCycle: 'Hold Cycle',
        industry: 'Industry'
      }
    },
    project: {
      main: {
        no: 'No.',
        title: 'Title',
        amount: 'Signed Amount (Million Yuan)',
        industry: 'Industry',
        state: 'Status',
        phrase: 'Project Phase',
        type: 'Category',
        enterprise: 'Enterprise',
        keyProject: 'Key Project',
        yes: 'Yes',
        orNo: 'No',
        country: 'Country',
        date: 'Contract Date',
        biddingProjectType: 'Bidding Project Type',
        projectDomain: 'Project Domain',
      },
      history: {
        title: 'Previous Search',
        columns: {
          title: 'Previous Search Criteria',
          top: 'Top',
          delete: 'Delete'
        }
      }
    },
    history: {
      title: 'Previous Search',
      columns: {
        title: 'Previous Search Criteria'
      }
    },
    topic:{
      list:{
        no: 'No.',
        title: 'Title',
        summary: 'Summary',
        releaseTime: 'Release Time'
      }
    },
    myProject: {
      columns:{
        title:'Title',
        status:'Status',
        time:'Publish Time',
        operate:'Operate',
      },
      operate:{
        edit:'Edit',
        delete:'Delete',
      }
    },
    analysis:{
      num:'Quantity',
      amount: 'Amount',
      date: 'Date',
      source:'Source',
      type:'Category',
      percentage:'Percentage',
      positive:'Quantity of Positive Information',
      negative:'Quantity of Negative Information'
    },
  },
  datePicker: {
    threeMonths: 'Latest 3 Months',
    oneYear: 'Latest 1 Year',
    threeYears: 'Latest 3 Years'
  },
  rules: {
    maximum: 'No More Than {num} Characters',
    publishProject: {
      maximum100: 'No More Than 100 Characters',
      maximum50: 'No More Than 50 Characters',
      number: 'Number Only',
      contact: {
        mobile1: 'Invalid Mobile Format',
        email1: 'Invalid Email Format',
        telephone1: 'Invalid Telephone Format',
        mobile2: 'Invalid Mobile Phone Format',
        email2: 'Invalid Email Format',
        telephone2: 'Invalid Telephone Format'
      }
    }
  }
}
